// Mock data for GIPSOVINIL.KZ website

export const translations = {
  ru: {
    nav: {
      home: 'Главная',
      about: 'О компании',
      products: 'Продукция',
      projects: 'Проекты',
      services: 'Услуги',
      contact: 'Контакты'
    },
    hero: {
      title: 'Первый и специализированный завод по производству гипсовиниловых панелей в Казахстане',
      subtitle: 'Профессиональные решения для застройщиков, проектировщиков, коммерческих и государственных объектов',
      cta1: 'Получить консультацию',
      cta2: 'Каталог продукции'
    },
    stats: {
      production: 'м² в месяц',
      productionLabel: 'Производственная мощность',
      experience: 'лет',
      experienceLabel: 'Ведущая экспертиза отрасли',
      projects: '+',
      projectsLabel: 'Реализованных проектов',
      speed: 'раза быстрее',
      speedLabel: 'Монтаж по сравнению с традиционными методами'
    },
    about: {
      title: 'Большая идея',
      subtitle: 'Помогать Казахстану строиться красиво',
      description: 'Мы верим, что качественная среда влияет на мышление и поведение человека. Наша миссия — создавать инновационные решения для современной отделки стен, которые делают пространства безопасными, эстетичными и функциональными.',
      features: [
        {
          title: 'Собственное производство',
          description: 'Производственная база в Астане, СЭЗ'
        },
        {
          title: 'Сертифицированная продукция',
          description: 'СТ КЗ, КазНИИСА, СЭС, пожарная служба'
        },
        {
          title: 'Сервис 360°',
          description: 'Полный цикл от проектирования до монтажа'
        },
        {
          title: 'Большие объемы',
          description: 'Готовность к крупным проектам любой сложности'
        }
      ]
    },
    services: {
      title: 'Наш сервис 360°',
      subtitle: 'Комплексное решение для вашего проекта',
      items: [
        {
          title: 'Гибкая программа скидок',
          description: 'Индивидуальные условия для каждого проекта'
        },
        {
          title: 'Бесплатный шеф-монтаж',
          description: 'Профессиональный надзор за монтажными работами'
        },
        {
          title: 'Выезд с образцами',
          description: 'Полноразмерные образцы на вашем объекте'
        },
        {
          title: 'Дизайнерские решения',
          description: 'Собственный проектный отдел для ваших задач'
        },
        {
          title: 'Готовность к большим проектам',
          description: 'Производственные мощности для любых объемов'
        },
        {
          title: 'Быстрая поставка',
          description: 'Большой складской запас для срочных заказов'
        }
      ]
    },
    products: {
      title: 'Революция в отделке стен',
      subtitle: 'Инновационный материал для современного строительства',
      description: 'Гипсовиниловые панели — это готовое решение для отделки стен, которое сочетает красоту, долговечность и простоту монтажа.',
      features: [
        'Монтаж в 5-7 раз быстрее традиционных методов',
        'Огнестойкость класса Г1',
        'Влагостойкость и простота ухода',
        'Экологичность и безопасность',
        'Высота панелей до 3 метров',
        'Широкая палитра цветов и текстур'
      ],
      types: [
        {
          name: 'Панели на основе гипсокартона (ГКЛ)',
          description: 'Идеально для внутренней отделки жилых и коммерческих помещений'
        },
        {
          name: 'Панели на основе влагостойкого гипсокартона (ГКЛВ)',
          description: 'Повышенная влагостойкость для помещений с высокой влажностью'
        },
        {
          name: 'Панели на основе стекломагниевого листа (СМЛ)',
          description: 'Негорючий материал для объектов с повышенными требованиями пожарной безопасности'
        },
        {
          name: 'Панели на основе фиброцементной плиты',
          description: 'Максимальная прочность и долговечность для высоконагруженных зон'
        }
      ]
    },
    applications: {
      title: 'Решаем конкретные задачи конкретного бизнеса',
      items: [
        {
          title: 'Государственные учреждения',
          description: 'Соответствие всем нормативам, быстрый монтаж, долговечность'
        },
        {
          title: 'HoReCa',
          description: 'Простота ухода, влагостойкость, современный дизайн'
        },
        {
          title: 'Медицинские учреждения',
          description: 'Гигиеничность, огнестойкость, антивандальность'
        },
        {
          title: 'Коммерческая недвижимость',
          description: 'Презентабельный вид, быстрый монтаж, износостойкость'
        },
        {
          title: 'Образовательные учреждения',
          description: 'Экологичность, безопасность, простота обслуживания'
        },
        {
          title: 'Застройщики',
          description: 'Скорость сдачи объекта, снижение затрат, качество'
        }
      ]
    },
    projects: {
      title: 'Построено с гипсовиниловыми панелями GIPSOVINIL.KZ',
      filter: {
        all: 'Все проекты',
        commercial: 'Коммерческие',
        education: 'Образование',
        healthcare: 'Медицина',
        horeca: 'HoReCa'
      }
    },
    advantages: {
      title: 'Почему выбирают GIPSOVINIL.KZ',
      items: [
        {
          title: 'Технологичная альтернатива',
          description: 'Превосходит покраску, штукатурку и традиционные панели по скорости и качеству'
        },
        {
          title: 'Разнообразие основ',
          description: 'ГКЛ, ГКЛВ, СМЛ, фиброцемент — решение для любой задачи'
        },
        {
          title: 'Модульная сборка',
          description: 'Возможность легкого демонтажа и замены отдельных элементов'
        },
        {
          title: 'Авторская коллекция',
          description: 'Эксклюзивные цвета и текстуры от наших дизайнеров'
        },
        {
          title: 'Made in Kazakhstan',
          description: 'Поддержка отечественного производителя и архитектурной культуры страны'
        }
      ]
    },
    contact: {
      title: 'Остались вопросы?',
      subtitle: 'Свяжитесь с нами удобным способом',
      form: {
        name: 'Ваше имя',
        phone: 'Телефон',
        email: 'Email',
        message: 'Сообщение',
        submit: 'Отправить заявку',
        success: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
        error: 'Произошла ошибка. Попробуйте позже.'
      },
      whatsapp: 'Написать в WhatsApp',
      info: {
        address: 'г. Астана, Специальная экономическая зона',
        phone: '+7 (XXX) XXX-XX-XX',
        email: 'info@gipsovinil.kz',
        hours: 'Пн-Пт: 9:00 - 18:00'
      }
    },
    footer: {
      about: 'О компании',
      aboutText: 'ТОО «ГИПСОВИНИЛ» — первый и специализированный завод по производству гипсовиниловых панелей в Казахстане.',
      quickLinks: 'Быстрые ссылки',
      products: 'Продукция',
      contact: 'Контакты',
      social: 'Социальные сети',
      rights: '© 2024 ТОО «ГИПСОВИНИЛ». Все права защищены.'
    }
  },
  kz: {
    nav: {
      home: 'Басты бет',
      about: 'Компания туралы',
      products: 'Өнімдер',
      projects: 'Жобалар',
      contact: 'Байланыс'
    },
    hero: {
      title: 'Қазақстандағы гипсвинил панельдерін өндірудің алғашқы және мамандандырылған зауыты',
      subtitle: 'Құрылысшылар, жобалаушылар, коммерциялық және мемлекеттік объектілер үшін кәсіби шешімдер',
      cta1: 'Кеңес алу',
      cta2: 'Өнім каталогы'
    },
    stats: {
      production: 'м² айына',
      productionLabel: 'Өндіріс қуаты',
      experience: 'жыл',
      experienceLabel: 'Саладағы жетекші сарапшылық',
      projects: '+',
      projectsLabel: 'Іске асырылған жобалар',
      speed: 'есе жылдам',
      speedLabel: 'Дәстүрлі әдістермен салыстырғанда монтаж'
    },
    about: {
      title: 'Үлкен идея',
      subtitle: 'Қазақстанды әдемі салуға көмектесу',
      description: 'Біз сапалы орта адамның ойлау мен мінез-құлқына әсер ететініне сенеміз. Біздің миссиямыз - кеңістіктерді қауіпсіз, эстетикалық және функционалды ететін қабырға өңдеуінің инновациялық шешімдерін жасау.',
      features: [
        {
          title: 'Өз өндірісі',
          description: 'Астанадағы өндірістік база, ЭЗА'
        },
        {
          title: 'Сертификатталған өнім',
          description: 'СТ ҚЗ, ҚазҒҒЗИ, СЭЗ, өрт қызметі'
        },
        {
          title: 'Қызмет 360°',
          description: 'Жобалаудан монтажға дейінгі толық цикл'
        },
        {
          title: 'Үлкен көлемдер',
          description: 'Кез келген күрделілікте ірі жобаларға дайындық'
        }
      ]
    },
    services: {
      title: 'Біздің қызмет 360°',
      subtitle: 'Сіздің жобаңыз үшін кешенді шешім',
      items: [
        {
          title: 'Жеңілдіктердің икемді бағдарламасы',
          description: 'Әрбір жоба үшін жеке шарттар'
        },
        {
          title: 'Тегін шеф-монтаж',
          description: 'Монтаж жұмыстарына кәсіби қадағалау'
        },
        {
          title: 'Үлгілермен шығу',
          description: 'Сіздің объектіңізде толық өлшемді үлгілер'
        },
        {
          title: 'Дизайнерлік шешімдер',
          description: 'Сіздің міндеттеріңіз үшін өз жобалық бөлімі'
        },
        {
          title: 'Үлкен жобаларға дайындық',
          description: 'Кез келген көлем үшін өндірістік қуаттар'
        },
        {
          title: 'Жылдам жеткізу',
          description: 'Шұғыл тапсырыстар үшін үлкен қойма қоры'
        }
      ]
    },
    products: {
      title: 'Қабырға өңдеуіндегі революция',
      subtitle: 'Қазіргі құрылыс үшін инновациялық материал',
      description: 'Гипсвинил панельдері - бұл сұлулық, төзімділік және монтаждың қарапайымдылығын біріктіретін қабырғаларды өңдеудің дайын шешімі.',
      features: [
        'Дәстүрлі әдістерден 5-7 есе жылдам монтаж',
        'Г1 сыныбындағы өртке төзімділік',
        'Ылғалға төзімділік және күтімнің қарапайымдылығы',
        'Экологиялық таза және қауіпсіз',
        '3 метрге дейін панель биіктігі',
        'Түстер мен текстуралардың кең палитрасы'
      ],
      types: [
        {
          name: 'Гипсокартон негізіндегі панельдер (ГКЛ)',
          description: 'Тұрғын үй және коммерциялық үй-жайларды ішкі өңдеуге өте жарамды'
        },
        {
          name: 'Ылғалға төзімді гипсокартон негізіндегі панельдер (ГКЛВ)',
          description: 'Жоғары ылғалдылығы бар үй-жайлар үшін жоғарылатылған ылғалға төзімділік'
        },
        {
          name: 'Әйнекмагний парағы негізіндегі панельдер (СМЛ)',
          description: 'Өрт қауіпсіздігінің жоғары талаптары бар объектілер үшін жанбайтын материал'
        },
        {
          name: 'Фиброцемент плитасы негізіндегі панельдер',
          description: 'Жоғары жүктемелі аймақтар үшін максималды беріктік және төзімділік'
        }
      ]
    },
    applications: {
      title: 'Нақты бизнестің нақты міндеттерін шешеміз',
      items: [
        {
          title: 'Мемлекеттік мекемелер',
          description: 'Барлық нормаларға сәйкестік, жылдам монтаж, төзімділік'
        },
        {
          title: 'HoReCa',
          description: 'Күтімнің қарапайымдылығы, ылғалға төзімділік, заманауи дизайн'
        },
        {
          title: 'Медициналық мекемелер',
          description: 'Гигиена, өртке төзімділік, антивандалдық'
        },
        {
          title: 'Коммерциялық жылжымайтын мүлік',
          description: 'Көрнекті көрініс, жылдам монтаж, тозуға төзімділік'
        },
        {
          title: 'Білім беру мекемелері',
          description: 'Экологиялық таза, қауіпсіздік, қызмет көрсетудің қарапайымдылығы'
        },
        {
          title: 'Құрылысшылар',
          description: 'Объектіні тапсыру жылдамдығы, шығындарды азайту, сапа'
        }
      ]
    },
    projects: {
      title: 'GIPSOVINIL.KZ гипсвинил панельдерімен салынған',
      filter: {
        all: 'Барлық жобалар',
        commercial: 'Коммерциялық',
        education: 'Білім беру',
        healthcare: 'Медицина',
        horeca: 'HoReCa'
      }
    },
    advantages: {
      title: 'Неліктен GIPSOVINIL.KZ таңдайды',
      items: [
        {
          title: 'Технологиялық балама',
          description: 'Жылдамдық пен сапа бойынша бояуды, сылауды және дәстүрлі панельдерді асып түседі'
        },
        {
          title: 'Негіздердің әртүрлілігі',
          description: 'ГКЛ, ГКЛВ, СМЛ, фиброцемент - кез келген міндет үшін шешім'
        },
        {
          title: 'Модульдік құрастыру',
          description: 'Жеке элементтерді оңай бөлшектеу және ауыстыру мүмкіндігі'
        },
        {
          title: 'Авторлық коллекция',
          description: 'Біздің дизайнерлеріміздің эксклюзивті түстері мен текстуралары'
        },
        {
          title: 'Қазақстанда жасалған',
          description: 'Отандық өндірушіні және елдің сәулет мәдениетін қолдау'
        }
      ]
    },
    contact: {
      title: 'Сұрақтар қалдыңыз ба?',
      subtitle: 'Бізбен ыңғайлы тәсілмен байланысыңыз',
      form: {
        name: 'Сіздің атыңыз',
        phone: 'Телефон',
        email: 'Email',
        message: 'Хабарлама',
        submit: 'Өтінімді жіберу',
        success: 'Рахмет! Біз жақын арада сізбен байланысамыз.',
        error: 'Қате орын алды. Кейінірек қайталап көріңіз.'
      },
      whatsapp: 'WhatsApp-қа жазу',
      info: {
        address: 'Астана қ., Арнайы экономикалық аймақ',
        phone: '+7 (XXX) XXX-XX-XX',
        email: 'info@gipsovinil.kz',
        hours: 'Дс-Жм: 9:00 - 18:00'
      }
    },
    footer: {
      about: 'Компания туралы',
      aboutText: '«ГИПСОВИНИЛ» ЖШС - Қазақстандағы гипсвинил панельдерін өндірудің алғашқы және мамандандырылған зауыты.',
      quickLinks: 'Жылдам сілтемелер',
      products: 'Өнімдер',
      contact: 'Байланыс',
      social: 'Әлеуметтік желілер',
      rights: '© 2024 «ГИПСОВИНИЛ» ЖШС. Барлық құқықтар қорғалған.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      projects: 'Projects',
      contact: 'Contact'
    },
    hero: {
      title: 'The First and Specialized Plant for Production of Gypsum-Vinyl Panels in Kazakhstan',
      subtitle: 'Professional Solutions for Developers, Designers, Commercial and Government Facilities',
      cta1: 'Get Consultation',
      cta2: 'Product Catalog'
    },
    stats: {
      production: 'm² per month',
      productionLabel: 'Production Capacity',
      experience: 'years',
      experienceLabel: 'Industry Leading Expertise',
      projects: '+',
      projectsLabel: 'Completed Projects',
      speed: 'times faster',
      speedLabel: 'Installation compared to traditional methods'
    },
    about: {
      title: 'Big Idea',
      subtitle: 'Helping Kazakhstan Build Beautifully',
      description: 'We believe that quality environment influences human thinking and behavior. Our mission is to create innovative solutions for modern wall finishing that make spaces safe, aesthetic, and functional.',
      features: [
        {
          title: 'Own Production',
          description: 'Production facility in Astana, SEZ'
        },
        {
          title: 'Certified Products',
          description: 'ST KZ, KazNIISA, SES, fire service'
        },
        {
          title: '360° Service',
          description: 'Full cycle from design to installation'
        },
        {
          title: 'Large Volumes',
          description: 'Ready for large projects of any complexity'
        }
      ]
    },
    services: {
      title: 'Our 360° Service',
      subtitle: 'Comprehensive Solution for Your Project',
      items: [
        {
          title: 'Flexible Discount Program',
          description: 'Individual terms for each project'
        },
        {
          title: 'Free Installation Supervision',
          description: 'Professional oversight of installation works'
        },
        {
          title: 'Site Visit with Samples',
          description: 'Full-size samples at your facility'
        },
        {
          title: 'Design Solutions',
          description: 'In-house design department for your needs'
        },
        {
          title: 'Ready for Large Projects',
          description: 'Production capacity for any volume'
        },
        {
          title: 'Fast Delivery',
          description: 'Large warehouse stock for urgent orders'
        }
      ]
    },
    products: {
      title: 'Revolution in Wall Finishing',
      subtitle: 'Innovative Material for Modern Construction',
      description: 'Gypsum-vinyl panels are a ready-made solution for wall finishing that combines beauty, durability, and ease of installation.',
      features: [
        'Installation 5-7 times faster than traditional methods',
        'Fire resistance class G1',
        'Moisture resistance and easy maintenance',
        'Eco-friendly and safe',
        'Panel height up to 3 meters',
        'Wide range of colors and textures'
      ],
      types: [
        {
          name: 'Gypsum Board Based Panels (GKL)',
          description: 'Ideal for interior finishing of residential and commercial spaces'
        },
        {
          name: 'Moisture-Resistant Gypsum Board Panels (GKLV)',
          description: 'Enhanced moisture resistance for high-humidity environments'
        },
        {
          name: 'Glass-Magnesium Board Panels (SML)',
          description: 'Non-combustible material for facilities with high fire safety requirements'
        },
        {
          name: 'Fiber Cement Board Panels',
          description: 'Maximum strength and durability for high-traffic areas'
        }
      ]
    },
    applications: {
      title: 'Solving Specific Business Challenges',
      items: [
        {
          title: 'Government Facilities',
          description: 'Compliance with all standards, fast installation, durability'
        },
        {
          title: 'HoReCa',
          description: 'Easy maintenance, moisture resistance, modern design'
        },
        {
          title: 'Healthcare Facilities',
          description: 'Hygiene, fire resistance, vandal-proof'
        },
        {
          title: 'Commercial Real Estate',
          description: 'Presentable appearance, fast installation, wear resistance'
        },
        {
          title: 'Educational Institutions',
          description: 'Eco-friendly, safe, easy maintenance'
        },
        {
          title: 'Developers',
          description: 'Faster project completion, cost reduction, quality'
        }
      ]
    },
    projects: {
      title: 'Built with GIPSOVINIL.KZ Panels',
      filter: {
        all: 'All Projects',
        commercial: 'Commercial',
        education: 'Education',
        healthcare: 'Healthcare',
        horeca: 'HoReCa'
      }
    },
    advantages: {
      title: 'Why Choose GIPSOVINIL.KZ',
      items: [
        {
          title: 'Technological Alternative',
          description: 'Surpasses painting, plastering and traditional panels in speed and quality'
        },
        {
          title: 'Variety of Bases',
          description: 'GKL, GKLV, SML, fiber cement - solution for any task'
        },
        {
          title: 'Modular Assembly',
          description: 'Easy disassembly and replacement of individual elements'
        },
        {
          title: 'Signature Collection',
          description: 'Exclusive colors and textures from our designers'
        },
        {
          title: 'Made in Kazakhstan',
          description: 'Supporting domestic production and architectural culture'
        }
      ]
    },
    contact: {
      title: 'Have Questions?',
      subtitle: 'Contact us in a convenient way',
      form: {
        name: 'Your Name',
        phone: 'Phone',
        email: 'Email',
        message: 'Message',
        submit: 'Submit Request',
        success: 'Thank you! We will contact you shortly.',
        error: 'An error occurred. Please try again later.'
      },
      whatsapp: 'WhatsApp Us',
      info: {
        address: 'Astana, Special Economic Zone',
        phone: '+7 (XXX) XXX-XX-XX',
        email: 'info@gipsovinil.kz',
        hours: 'Mon-Fri: 9:00 AM - 6:00 PM'
      }
    },
    footer: {
      about: 'About',
      aboutText: 'LLP "GIPSOVINIL" is the first and specialized plant for production of gypsum-vinyl panels in Kazakhstan.',
      quickLinks: 'Quick Links',
      products: 'Products',
      contact: 'Contact',
      social: 'Social Media',
      rights: '© 2024 LLP "GIPSOVINIL". All rights reserved.'
    }
  }
,
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'عن الشركة',
      products: 'المنتجات',
      projects: 'المشاريع',
      services: 'الخدمات',
      contact: 'تواصل معنا'
    },
    hero: {
      title: 'أول مصنع متخصص لإنتاج الألواح الجبسوفينيلية في كازاخستان',
      subtitle: 'حلول احترافية للمطورين العقاريين والمصممين والمنشآت التجارية والحكومية',
      cta1: 'احصل على استشارة',
      cta2: 'كتالوج المنتجات'
    },
    stats: {
      production: 'م² شهرياً',
      productionLabel: 'الطاقة الإنتاجية',
      experience: 'سنوات',
      experienceLabel: 'خبرة رائدة في القطاع',
      projects: '+',
      projectsLabel: 'مشروع منجز',
      speed: 'أضعاف',
      speedLabel: 'سرعة التركيب مقارنةً بالأساليب التقليدية'
    },
    about: {
      title: 'الفكرة الكبرى',
      subtitle: 'مساعدة كازاخستان على البناء بأسلوب راقٍ',
      description: 'نؤمن بأن جودة البيئة المحيطة تؤثر في تفكير الإنسان وسلوكه. مهمتنا هي ابتكار حلول متطورة لتشطيب الجدران الداخلية، تجعل الفضاءات آمنة وجمالية ووظيفية في آنٍ واحد.',
      features: [
        {
          title: 'تصنيع ذاتي',
          description: 'قاعدة إنتاجية في أستانا، المنطقة الاقتصادية الخاصة'
        },
        {
          title: 'منتجات معتمدة',
          description: 'ST KZ، KazNIISA، SES، الدفاع المدني'
        },
        {
          title: 'خدمة 360°',
          description: 'دورة متكاملة من التصميم حتى التركيب'
        },
        {
          title: 'طاقة إنتاجية عالية',
          description: 'استعداد تام لتنفيذ المشاريع الكبرى بأي مستوى من التعقيد'
        }
      ]
    },
    services: {
      title: 'خدمتنا 360°',
      subtitle: 'حل متكامل لمشروعك',
      items: [
        {
          title: 'برنامج خصومات مرن',
          description: 'شروط مخصصة لكل مشروع على حدة'
        },
        {
          title: 'إشراف تركيب مجاني',
          description: 'إشراف احترافي على أعمال التركيب'
        },
        {
          title: 'زيارة ميدانية بالعينات',
          description: 'عينات بالحجم الكامل في موقع مشروعك'
        },
        {
          title: 'حلول تصميم داخلي',
          description: 'قسم تصميم داخلي متخصص لتلبية متطلباتك'
        },
        {
          title: 'قدرة على المشاريع الكبرى',
          description: 'طاقة إنتاجية تستوعب أي حجم من الطلبات'
        },
        {
          title: 'توصيل سريع',
          description: 'مخزون ضخم يلبي الطلبات العاجلة'
        }
      ]
    },
    products: {
      title: 'ثورة في تشطيب الجدران',
      subtitle: 'مواد مبتكرة للبناء المعاصر',
      description: 'الألواح الجبسوفينيلية حل جاهز لتشطيب الجدران يجمع بين الجماليات والمتانة وسهولة التركيب.',
      features: [
        'تركيب أسرع 5 إلى 7 مرات من الأساليب التقليدية',
        'مقاومة للحريق من الفئة Г1',
        'مقاومة للرطوبة وسهولة الصيانة',
        'صديق للبيئة وآمن للاستخدام',
        'ارتفاع الألواح يصل إلى 3 م',
        'مجموعة واسعة من الألوان والأسطح'
      ],
      types: [
        {
          name: 'ألواح على أساس الجبس المغلف (GKL)',
          description: 'مثالية للتشطيب الداخلي للمساحات السكنية والتجارية'
        },
        {
          name: 'ألواح على أساس الجبس المغلف المقاوم للرطوبة (GKLV)',
          description: 'مقاومة رطوبة عالية للمساحات ذات الرطوبة المرتفعة'
        },
        {
          name: 'ألواح على أساس الألواح الزجاجية المغنيزيوية (SML)',
          description: 'مادة غير قابلة للاشتعال للمنشآت ذات متطلبات السلامة من الحريق المشددة'
        },
        {
          name: 'ألواح على أساس الألواح الليفية الأسمنتية',
          description: 'أقصى درجات المتانة والديمومة للمناطق ذات الأحمال العالية'
        }
      ]
    },
    applications: {
      title: 'نقدم حلولاً محددة لاحتياجات كل قطاع أعمال',
      items: [
        {
          title: 'المنشآت الحكومية',
          description: 'استيفاء كامل للمعايير واللوائح، سرعة التركيب، متانة طويلة الأمد'
        },
        {
          title: 'HoReCa',
          description: 'سهولة الصيانة، مقاومة الرطوبة، تصميم عصري'
        },
        {
          title: 'المنشآت الطبية',
          description: 'النظافة الصحية، مقاومة الحريق، مقاومة التخريب'
        },
        {
          title: 'العقارات التجارية',
          description: 'مظهر راقٍ، سرعة التركيب، مقاومة البلى'
        },
        {
          title: 'المنشآت التعليمية',
          description: 'صديق للبيئة، آمن الاستخدام، سهل الصيانة'
        },
        {
          title: 'المطورون العقاريون',
          description: 'سرعة تسليم المشاريع، خفض التكاليف، جودة عالية'
        }
      ]
    },
    projects: {
      title: 'مشاريع أُنجزت بألواح جيبسوفينيل GIPSOVINIL.KZ',
      filter: {
        all: 'جميع المشاريع',
        commercial: 'تجارية',
        education: 'تعليمية',
        healthcare: 'طبية',
        horeca: 'HoReCa'
      }
    },
    advantages: {
      title: 'لماذا يختارون GIPSOVINIL.KZ',
      items: [
        {
          title: 'بديل تقني متطور',
          description: 'يتفوق على الدهان والجص والألواح التقليدية في السرعة والجودة'
        },
        {
          title: 'تنوع في القواعد الإنشائية',
          description: 'GKL، GKLV، SML، الليف الأسمنتي — حل لكل متطلب'
        },
        {
          title: 'تركيب معياري',
          description: 'إمكانية الفك والاستبدال السهل للعناصر الفردية'
        },
        {
          title: 'مجموعة تصميمية خاصة',
          description: 'ألوان وأسطح حصرية من تصميم فريقنا الإبداعي'
        },
        {
          title: 'صُنع في كازاخستان',
          description: 'دعم الصناعة الوطنية والإرث المعماري للبلاد'
        }
      ]
    },
    contact: {
      title: 'هل لديك استفسارات؟',
      subtitle: 'تواصل معنا بالطريقة التي تناسبك',
      form: {
        name: 'اسمك',
        phone: 'رقم الهاتف',
        email: 'Email',
        message: 'رسالتك',
        submit: 'إرسال الطلب',
        success: 'شكراً لك! سنتواصل معك في أقرب وقت ممكن.',
        error: 'حدث خطأ. يرجى المحاولة لاحقاً.'
      },
      whatsapp: 'المراسلة عبر WhatsApp',
      info: {
        address: 'أستانا، المنطقة الاقتصادية الخاصة',
        phone: '+7 (XXX) XXX-XX-XX',
        email: 'info@gipsovinil.kz',
        hours: 'الاثنين - الجمعة: 9:00 - 18:00'
      }
    },
    footer: {
      about: 'عن الشركة',
      aboutText: 'شركة «جيبسوفينيل» ذات المسؤولية المحدودة — أول مصنع متخصص لإنتاج الألواح الجبسوفينيلية في كازاخستان.',
      quickLinks: 'روابط سريعة',
      products: 'المنتجات',
      contact: 'تواصل معنا',
      social: 'وسائل التواصل الاجتماعي',
      rights: '© 2024 شركة «جيبسوفينيل» ذات المسؤولية المحدودة. جميع الحقوق محفوظة.'
    }
  }
};

export const mockProjects = [
  {
    id: 1,
    title: {
      ru: 'Бизнес-центр "Астана-Сити"',
      kz: '"Астана-Сити" бизнес-орталығы',
      en: '"Astana-City" Business Center',
      ar: 'مركز الأعمال "Астана-Сити"'
    },
    category: 'commercial',
    image: 'https://images.unsplash.com/photo-1651666176094-2bef8442db12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzc0MDkzMTIwfDA&ixlib=rb-4.1.0&q=85',
    area: '5000'
  },
  {
    id: 2,
    title: {
      ru: 'Университет "Нур-Султан"',
      kz: '"Нұр-Сұлтан" университеті',
      en: '"Nur-Sultan" University',
      ar: 'جامعة "Нур-Султан"'
    },
    category: 'education',
    image: 'https://images.unsplash.com/photo-1665492095698-8ea8406cdf2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxlZHVjYXRpb25hbCUyMGZhY2lsaXR5fGVufDB8fHx8MTc3NDA5MzEyOHww&ixlib=rb-4.1.0&q=85',
    area: '8500'
  },
  {
    id: 3,
    title: {
      ru: 'Медицинский центр "Здоровье"',
      kz: '"Денсаулық" медициналық орталығы',
      en: '"Health" Medical Center',
      ar: 'المركز الطبي "Здоровье"'
    },
    category: 'healthcare',
    image: 'https://images.unsplash.com/photo-1710074213379-2a9c2653046a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzc0MDkzMTM1fDA&ixlib=rb-4.1.0&q=85',
    area: '3200'
  },
  {
    id: 4,
    title: {
      ru: 'Ресторан "Dastarkhan"',
      kz: '"Dastarkhan" мейрамханасы',
      en: '"Dastarkhan" Restaurant',
      ar: 'مطعم "Dastarkhan"'
    },
    category: 'horeca',
    image: 'https://images.unsplash.com/photo-1667388969250-1c7220bf3f37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc0MDkzMTQwfDA&ixlib=rb-4.1.0&q=85',
    area: '450'
  },
  {
    id: 5,
    title: {
      ru: 'Торговый центр "Mega"',
      kz: '"Mega" сауда орталығы',
      en: '"Mega" Shopping Center',
      ar: 'المركز التجاري "Mega"'
    },
    category: 'commercial',
    image: 'https://images.unsplash.com/photo-1632398793634-e3cd63fc9e84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzc0MDkzMTIwfDA&ixlib=rb-4.1.0&q=85',
    area: '12000'
  },
  {
    id: 6,
    title: {
      ru: 'Школа №45',
      kz: '№45 мектеп',
      en: 'School №45',
      ar: 'مدرسة رقم 45'
    },
    category: 'education',
    image: 'https://images.unsplash.com/photo-1769430886896-dc30842be5a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxlZHVjYXRpb25hbCUyMGZhY2lsaXR5fGVufDB8fHx8MTc3NDA5MzEyOHww&ixlib=rb-4.1.0&q=85',
    area: '4500'
  },
  {
    id: 7,
    title: {
      ru: 'Клиника "МедЛайф"',
      kz: '"МедЛайф" клиникасы',
      en: '"MedLife" Clinic',
      ar: 'عيادة "МедЛайф"'
    },
    category: 'healthcare',
    image: 'https://images.pexels.com/photos/263402/pexels-photo-263402.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    area: '2800'
  },
  {
    id: 8,
    title: {
      ru: 'Кафе "Coffee House"',
      kz: '"Coffee House" кафесі',
      en: '"Coffee House" Cafe',
      ar: 'مقهى "Coffee House"'
    },
    category: 'horeca',
    image: 'https://images.unsplash.com/photo-1538333581680-29dd4752ddf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxyZXN0YXVyYW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc0MDkzMTQwfDA&ixlib=rb-4.1.0&q=85',
    area: '280'
  }
];

export const mockStats = {
  production: '50,000',
  experience: '5',
  projects: '150',
  speed: '5-7'
};

export const clientLogos = [
  { name: 'Client 1', logo: null },
  { name: 'Client 2', logo: null },
  { name: 'Client 3', logo: null },
  { name: 'Client 4', logo: null },
  { name: 'Client 5', logo: null },
  { name: 'Client 6', logo: null }
];
